import { HFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { dateAsDdMmYyyy } from 'util/date/formatDate'

import { AssinaturaEletronicaAtendTableFilterModel } from '../model-assinaturaEletronicaAtend'

export type AssinaturaEletronicaInfoProps = Omit<
  AssinaturaEletronicaAtendTableFilterModel,
  'criterioExibicao' | 'pageParams'
>

export function AssinaturaEletronicaAtendInfo(props: AssinaturaEletronicaInfoProps) {
  const { periodo } = props

  return (
    <HFlow>
      {(periodo?.startDate || periodo?.endDate) && (
        <HLabel title='Período:'>
          {dateAsDdMmYyyy(periodo?.startDate)} até {dateAsDdMmYyyy(periodo.endDate)}
        </HLabel>
      )}
    </HFlow>
  )
}
